import React, {Component, Fragment} from 'react'
import Table, {TableBody, TableHead, TableRow, TableCell} from 'components/CollapsibleTable'
import {DateTimeDisplay} from 'components/DateTimeDisplay'
import {FormContext} from 'components/FormContext'
import {Checkbox} from 'components/styled/Checkbox'
import Typography from '@material-ui/core/Typography'
import pluralize from 'pluralize'
import {Authorization} from 'utils'
import styles from './styles'
import Tooltip from '@material-ui/core/Tooltip'
import {FormattedMessage} from 'react-intl'

export class Review extends Component {
  static defaultProps = {
    name: 'account.steps.review',
    review: true
  }

  get ecddEnabled() {
    return !(this.props.context.status in {approved: true, pending_review: true})
  }

  renderSection = (label, name, date, children) =>
    <Fragment>
      <TableRow>
        <TableCell><FormattedMessage id={label} />: {name}</TableCell>
        <TableCell style={{textAlign: 'right'}}>
          {date && <DateTimeDisplay value={date} type="date"/>}
        </TableCell>
      </TableRow>
      {children &&
      <TableRow details>
        <TableCell colSpan={100} style={{padding: '10px 0', height: 'auto'}}>
          <Table secondary breakpoint={0}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Item</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {children}
            </TableBody>
          </Table>
        </TableCell>
      </TableRow>
      }
    </Fragment>

  renderItem = (status, name, nameValues, date) => {
    if (status === true)
      status = 'complete'
    if (status === false)
      status = 'incomplete'
    return (
      <TableRow>
        <TableCell style={{width: 24}}>{status && <img src={`/icons/${status}.png`} style={{width: 24}} alt="complete"/>}</TableCell>
        <TableCell><FormattedMessage id={name} values={nameValues} /></TableCell>
        <TableCell style={{textAlign: 'right'}}>
          {status !== 'incomplete' && date && <DateTimeDisplay value={date} type="date"/>}
        </TableCell>
      </TableRow>
    )
  }

  render = () => {
    const {context, onChange, showRequireAml}= this.props
    const issuer = context.type === 'issuerAccounts'
    const investorTerm = pluralize.singular(context.country.certificationHeading || 'Accredited Investors').toLowerCase()
    return (
      <div style={{paddingRight: 5}}>
        <Table breakpoint={1}>
          <TableBody>
            {this.renderSection(issuer ? 'account.issuer' : 'account.label', context.user.name, context.user.createdAt)}
            {this.renderSection('account.country_label', context.country.name, null,
              <Fragment>
                {!issuer && this.renderItem(!!context.certifiedAt, 'account.review.qualifies', {investorTerm}, context.certifiedAt)}
                {this.renderItem(!!context.disclaimerAcceptedAt, 'account.review.disclaimer', {}, context.disclaimerAcceptedAt)}
              </Fragment>
            )}
            {this.renderSection('account.entity_label', context.accountName, context.createdAt,
              <Fragment>
                {this.renderItem(context.status !== 'draft', 'account.review.registered', {}, context.registeredAt)}
                {this.renderItem(context.downloadsStatus, 'account.review.documents', {}, context.downloadsUpdatedAt)}
                {this.renderItem(context.personKycsStatus, 'account.review.kyc', {}, context.personKycsUpdatedAt)}
              </Fragment>
            )}
            <TableRow>
              <TableCell colSpan={100}>
                <FormattedMessage id="account.status_label" />
                : <span className={styles[context.status]}><FormattedMessage id={`account.status.${context.status}`} /></span>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <FormContext context={context} onChange={onChange}>
          {Authorization.admin && showRequireAml &&
          <Tooltip placement="bottom-start" title={this.ecddEnabled ? '' : <FormattedMessage id="account.ecdd.tooltip" />}>
            <Typography style={{marginLeft: -12, marginTop: 20}}>
              <Checkbox member="requireAml" disabled={!this.ecddEnabled} /><FormattedMessage id="account.ecdd.label" />
            </Typography>
          </Tooltip>
          }
        </FormContext>
      </div>
    )
  }
}